import React, {Component} from 'react'
import { Button } from 'reactstrap';

class StdButton  extends Component{
  
  constructor(props) {
	  super(props);
	  this.state = {disabled: false} 
  }

  componentDidMount() {
	  this.mounted = false
  }

  componentWillUnmount(){
	  this.mounted = false
  }

  render(){
	  const {id, buttonAction, buttonProps, action_text, children, className, confirmation} = this.props
	  const {disabled} = this.state
	  const clickAction = () => {
	    if(confirmation === false || confirm(confirmation) === true){		
		    if(typeof(buttonAction) === 'function'){
		      this.setState({disabled: true})
		      buttonAction(id).then(() => {
			      this.setState({disabled: false})})
		    }
	    }
	  }

	  if(children !== undefined && children !== null)
	    return (<button disabled={disabled} className={`content_button ${buttonProps.className}`}  onClick={clickAction}>
		    {children}
	    </button>)
		else
		  return (<Button disabled={disabled} {...buttonProps}  onClick={clickAction}>
			  <i className="fa fa-spinner fa-spin" style={{display: (disabled ? 'inline' : 'none')}}></i>
			  {action_text}			  
		  </Button>)
  }
}

StdButton.defaultProps = {
  buttonProps: {},
  confirmation: false
} 
export default StdButton
